// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__38zWv","validationTips":"StatementDescriptor_validationTips__2RaJG"};